angular.module("events")

    .controller("EventsBudgetListCtrl", ['event', 'LoginService', '$rootScope', '$scope', 'Restangular', 'gridService', 'modalService', '$uibModal', '$filter', '$translate', '$stateParams', '$state', 'uiGridConstants', '$timeout', '$q', '$http', 'uiGridTreeViewConstants', 'treeService', '$sce',
        function (event, LoginService, $rootScope, $scope, Restangular, gridService, modalService, $uibModal, $filter, $translate, $stateParams, $state, uiGridConstants, $timeout, $q, $http, uiGridTreeViewConstants, treeService, $sce) {
            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("EVENTS_BUDGET_READ");
            if(!Array.isArray($scope.$parent.menusItems)) {
                $state.go("events.edit", { id: $stateParams.id });
            } else {
                let results = $scope.$parent.menusItems.filter(m => m.id === parseInt($stateParams.menu_item_id, 10));
                if(results.length > 0) {
                    $scope.allowWrite &&= results[0].editable;
                } else {
                    $scope.allowWrite = false;
                }
            }

            $scope.hasResults = false;

            $rootScope.breadcrumb = [
                { title: $filter('translate')('events.title'), url: "events.list" },
                { title: $filter('translate')('events.title'), url: "events.list" },
                { title: $filter('translate')('events.budget.title') }
            ];
            function isDefinedAndNotNull(val) {
                return angular.isDefined(val) && val !== null;
            }
            $scope.event = event;
            $rootScope.breadcrumb = [
                { title: $filter('translate')('events.title'), url: "events.list" },
                { title: $scope.event.name, url: "events.edit({ id: " + $scope.event.id + " })" },
                { title: $filter('translate')('events.budget.title') }
            ];
            $rootScope.title = $scope.event.name + " - " + $filter('translate')('events.budget.title');

            $scope.gridBudget = {
                pdfTitle: $scope.event.name + " - " + $filter('date')($scope.event.date_from, 'dd/MM/yyyy HH:mm'),
                exporterPdfFooter: "footer",
                exporterMenuCsv: true,
                enableGridMenu: true,
                enablePaginationControls: false,
                enableFiltering: false,
                showColumnFooter: false,
                onRegisterApi: function (gridApi) {
                    this.gridApi = gridApi;
                },
                columnDefs: [
                    { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                    {
                        name: 'name', displayName: $filter('translate')('events.budget.name'), enableFiltering: false, enableHiding: false, enableColumnMenu: false,
                        cellTemplate: '<div ng-if="row.entity.id != 0" class="ui-grid-cell-contents" ng-bind-html="row.entity[col.field] | to_trusted"></div>'+
                            '<div ng-if="row.entity.id == 0" class="ui-grid-cell-contents"><b>{{row.entity[col.field]}}</b></div>'
                        ,customFormatFn: function (value) {
                            value = value.replace('<span style="margin-left: 15px;"></span>', '\r\t');
                            return value;
                        },
                    },
                    {
                        name: 'total', displayName: $filter('translate')('events.budget.total'), enableFiltering: false, enableHiding: false,
                        enableColumnMenu: false, width: 100, aggregationType: uiGridConstants.aggregationTypes.sum,
                        cellTemplate: '<div ng-if="row.entity.id != 0" class="ui-grid-cell-contents" style="text-align:center;">{{row.entity[col.field]}}</div>' +
                          '<div ng-if="row.entity.id == 0" class="ui-grid-cell-contents" style="text-align:center;"><b>{{row.entity[col.field]}}</b></div>'
                    }
                ],
                getData: function (options) {
                    var deferred = $q.defer();
                    options.event_id = $stateParams.id;
                    Restangular.all('EventsBudget').getList(options).then(function (result) {
                        $scope.hasResults = result.length > 0;
                        result.forEach(function (item) {
                            item.name = item.name.replace(/^\s+/g, '<span style="margin-left: 15px;"></span>'); //Le ponemos espacios para que indente

                        });

                        deferred.resolve(result);
                    });
                    return deferred.promise;
                }
            };
}])

;
